import { useEffect, useState } from "react";
import { IMG } from "../data/site";
import { PageHero, Section } from "../components/site/bits";
import { Stagger, StaggerItem } from "../components/site/motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");
  useEffect(() => { fetch(`${API}/news`).then((r) => r.json()).then(setItems).catch(() => setItems([])); }, []);
  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category)))];
  const shown = filter === "All" ? items : items.filter((i) => i.category === filter);
  return (
    <>
      <PageHero overline="News & Stories" lines={["From our", "community."]} image={IMG.foodBank}
        intro="Community activities, resident achievements, service updates and opportunities — the latest from Shelterease." />
      <Section>
        <div className="flex flex-wrap gap-3">
          {cats.map((c) => (
            <button key={c} data-testid={`news-filter-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setFilter(c)}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${filter === c ? "bg-brand-green text-white" : "border border-brand-dark/15 text-brand-slate hover:border-brand-green"}`}>{c}</button>
          ))}
        </div>
        <Stagger key={`${filter}-${shown.length}`} className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {shown.map((n) => (
            <StaggerItem key={n.id} className="group">
              <div className="overflow-hidden rounded-2xl"><img src={n.image} alt={n.title} className="h-60 w-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
              <div className="mt-5 flex items-center gap-3 text-xs">
                <span className="font-semibold uppercase tracking-wider text-brand-green">{n.category}</span>
                <span className="text-brand-slate/60">{new Date(n.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</span>
              </div>
              <h3 className="mt-2 font-serif text-2xl text-brand-dark transition-colors group-hover:text-brand-green">{n.title}</h3>
              <p className="mt-2 text-sm text-brand-slate">{n.excerpt}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </Section>
    </>
  );
}
